var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccommodation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15L18 8L8 15H17V28H19V15H28Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1399 18L8.17993 18.37L8.99993 22.74V28H10.9999L11.0199 24H12.9999V28H14.9999V22H10.8999L10.1399 18Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 22H21V28H23V24H24.98L25 28H27V22.74L27.82 18.37L25.86 18L25.1 22Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommodation);
export default __webpack_public_path__ + "static/media/accommodation.afa5eb29abb46afec9ed1b3ee8a82e17.svg";
export { ForwardRef as ReactComponent };